import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  cardAlert: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
    backgroundColor: '#eceff1',
    borderRadius: '4px',
    border: 'solid 1px #cfd8dc',
    boxShadow: 'none',
  },
  cardTitle: {
    fontWeight: 'bold',
    fontSize: '13px',
    color: '#003a52',
  },
  cardBody: {
    fontSize: '14px',
    color: '#1a334d',
    '& a': {
      fontWeight: 'bold',
      color: theme.palette.primary.main,
    },
  },
}));
